import { render } from "./NewKunde.vue?vue&type=template&id=3efbdd16&scoped=true"
import script from "./NewKunde.vue?vue&type=script&lang=js"
export * from "./NewKunde.vue?vue&type=script&lang=js"

import "./NewKunde.vue?vue&type=style&index=0&id=3efbdd16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efbdd16"]])

export default __exports__